import { DocumentNode } from '@apollo/client';

export function getOperationName(query: DocumentNode): string {
  const name = query.definitions.find(def => def.kind === 'OperationDefinition')?.name?.value;

  if (!name) throw new Error('Unable to find operation name');

  return name;
}
